import React, { useCallback, useState } from 'react';
import PubNub from 'Helpers/pubnub';
import { useDispatch, useSelector } from 'react-redux';
import WrapMessage from 'Containers/Teleconsult/Main/Messages/WrapMessage';
import { addModal } from 'Redux/modules/modal/actions';
import useIssuePrescription from 'Hooks/teleconsult/useIssuePrescription';
import { checkEligibleIssueMc } from 'Redux/modules/webChat/actions';
// eslint-disable-next-line max-len
import ModalAlertNotEligibleIssueMC from 'Containers/Teleconsult/Main/ModalAlertNotEligibleIssueMC/ModalAlertNotEligibleIssueMC';
import { MODAL_TYPES } from 'Constants/modal';

const BubbleChat = () => {
  const [isShowModalCannotIssueMC, setIsOpenModalCannotIssueMC] = useState(false);

  const dispatch = useDispatch();

  const sendMessage = useCallback((channelId, message) => {
    PubNub.sendMessage(channelId, message);
  }, []);

  const { activeContextGroup } = useSelector(state => state.webChat.contextMenu);

  const { onClickIssuePrescription } = useIssuePrescription(activeContextGroup);

  const [menuActions, setMenuActions] = useState({
    isOpenFinish: false,
  });

  const toggleFinishConsult = () =>
    setMenuActions({ ...menuActions, isOpenFinish: !menuActions.isOpenFinish });

  const openFinishConsult = () => {
    toggleFinishConsult();
  };

  const openMedicalCertModal = async () => {
    const {
      latestConsult: { id: consultId },
    } = activeContextGroup;
    try {
      await dispatch(checkEligibleIssueMc(consultId));
      dispatch(
        addModal({
          type: MODAL_TYPES.CREATE_MC,
          id: MODAL_TYPES.CREATE_MC,
          data: {
            conversation: activeContextGroup,
          },
        }),
      );
    } catch (error) {
      setIsOpenModalCannotIssueMC(true);
    }
  };

  const openCreateMemo = () => {
    dispatch(
      addModal({
        type: 'createMemo',
        id: 1,
        data: {
          conversation: activeContextGroup,
        },
      }),
    );
  };
  const openReferralMemo = () => {
    dispatch(
      addModal({
        type: 'referralMemo',
        id: 1,
        data: {
          conversation: activeContextGroup,
        },
      }),
    );
  };

  const openPosModal = () => {
    dispatch(
      addModal({
        type: 'posModal',
        id: 1,
        data: {
          conversation: activeContextGroup,
        },
      }),
    );
  };

  return (
    <div className="bubble-chat">
      <WrapMessage
        changeContextMenu={() => null}
        sendMessage={sendMessage}
        sendTypingEvent={() => null}
        openMedicalCertificate={openMedicalCertModal}
        openFinishConsult={openFinishConsult}
        openPrescriptionModal={onClickIssuePrescription}
        openReferralMemo={openReferralMemo}
        openPOS={openPosModal}
        openMemoRandum={openCreateMemo}
      />
      {isShowModalCannotIssueMC && (
        <ModalAlertNotEligibleIssueMC setOpen={setIsOpenModalCannotIssueMC} />
      )}
    </div>
  );
};

export default BubbleChat;
